import { Navigate, useLocation } from 'react-router-dom'

/** Redirection d'une ancienne adresse vers la nouvelle, en gardant ?paramètres et #ancre. */
export default function RedirectTo({ to }) {
  const location = useLocation()
  return <Navigate to={{ pathname: to, search: location.search, hash: location.hash }} replace />
}
